import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsFooter = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-footer", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsFooter;
